/**
 * 住院管家相关路由
 */
export default [
  /**
   * 选择医院
   */
  {
    path: '/charge/hos',
    meta: {
      title: '选择医院'
    },
    component: () => import('Pages/charge/hos')
  },
  /**
   * 选择就诊人
   */
  {
    path: '/charge/switch-patient',
    component: () => import('Pages/bind/switch-patient')
  },
  /**
   * 就诊卡充值
   */
  {
    path: '/charge/pay',
    component: () => import('Pages/charge/pay')
  },
  // /**
  //  * 充值记录
  //  */
  // {
  //   path: '/charge/records',
  //   component: () => import('Pages/charge/charge-records')
  // },
  /**
   * 充值成功
   */
  {
    path: '/charge/success',
    component: () => import('Pages/charge/success')
  }
]



// WEBPACK FOOTER //
// ./src/router/charge.js